<template>
  <div class="nx-searcher-filter-sections pr-4">
    <nx-taxonomy-selector
      disable-sort
      :type="types"
      :additional-filters="additionalFilters"
      :label="$t('message.searcher.filters.values.' + filter)"
      :value="multipleValue"
      :disabled="disabled"
      @input="updateFilter"
    />
  </div>
</template>

<script>
import NxTaxonomySelector from '@/modules/taxonomy/selector/Selector';
import MultiValueFilter from '@/components/filters/mixins/MultiValueFilter';
import Filter from '@/components/filters/components/Filter';

export default {
  name: 'NxSearcherFilterTaxonomy',
  components: {
    NxTaxonomySelector,
  },
  extends: Filter,
  mixins: [MultiValueFilter],
  props: {
    types: {
      type: Array,
      required: true,
    },
    additionalFilters: {
      type: Object,
      default: null,
    },
  },
  methods: {
    updateFilter(value) {
      this.$emit('input', this.filter, value.map(item => item.id));
    },
  },
};
</script>
